"use strict";

exports.__esModule = true;
exports.default = void 0;
var globals = Object.assign({
  settings: {},
  messages: {},
  features: {},
  publicUrl: '',
  root: ''
}, typeof global !== 'undefined' ? global.zeus : {});
var _default = exports.default = globals;